import { useEffect, useState } from 'react';
import { useFetch } from './useFetch';
import { env } from '../config'

export const thesaurusAnalyzeResultTypes = {
    match: "Match",
    suggestions: "Suggestions",
};

export const useFullAnalyze = (text, word, id) => {
    const [loading, setLoading] = useState(false);
    const {loading: fetchLoading, error, data, post, clean} = useFetch(`${env.REACT_APP_BASS_RAVMILIM_API_URL()}/AnalyzeText/FullAnalyze`);

    useEffect(() => {
        if (text && word && id && !(id.startsWith('t')) && !(id.startsWith('n'))) {
            post({text, word, id});
        }
        else {
            clean();
        }
    }, [text, word, id, post, clean]);

    useEffect(() => {
        let isActive = true;

        if (!fetchLoading) {
            setTimeout(() => {
                if (isActive) {
                    setLoading(false);
                }
            }, 500);
        }
        else {
            setLoading(true);
        }

        return () => {
            isActive = false;
        };
    }, [fetchLoading]);

    return {
        loading,
        error,
        data,
    };
};